import { useIsBlockingLoad } from '@/hooks/useQueryActivity';

/**
 * Thin indeterminate bar pinned to the top of the viewport whenever a query has
 * no data to show yet or a write is in flight. Purely additive — it overlays the
 * chrome rather than shifting layout.
 */
export function GlobalProgressBar() {
  const busy = useIsBlockingLoad();

  return (
    // Decorative: the busy state is announced via aria-busy on <main>, and the
    // per-panel skeletons carry the structure. A live progressbar role here
    // would just add noise on every poll.
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden" aria-hidden="true">
      <div
        className={`h-full bg-muted/40 transition-opacity duration-200 ${busy ? 'opacity-100' : 'opacity-0'}`}
      >
        <div className="h-full w-full origin-left animate-progress-sweep bg-primary motion-reduce:animate-none motion-reduce:translate-x-0 motion-reduce:scale-x-100" />
      </div>
    </div>
  );
}
